<template>
  <div id="home">
    <Welcome
      id="welcome"
      @abort="abort()"
      @complete="showbtn()"
      @scroll="goto('mission')"
    />
    <Transition start="black" end="#192026" />
    <About id="mission" />
    <Transition start="#192026" end="black" />
    <Career id="career" />
    <Transition start="black" end="#192026" />
    <Education id="education" />
    <!-- <Transition start="black" end="#192026" /> -->
    <!-- <Gallery id="projects" /> -->
    <!-- <Transition start="#192026" end="black" /> -->
    <Transition start="black" end="black" />
    <Footer id="contact" />

    <Menu
      :class="{
        slowtrans: !aborted,
        invisible: hidemenu,
      }"
      @goto="goto"
    />
  </div>
</template>

<script>
import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();

import Welcome from "@/components/Welcome";
import About from "@/components/About";
import Education from "@/components/Education";
import Career from "@/components/Career";
// import Gallery from "@/components/Gallery";
import Footer from "@/components/Footer";

import Transition from "@/components/Transition";
import Menu from "@/components/Menu";

export default {
  name: "Home",
  components: {
    About,
    Education,
    Career,
    // Gallery,
    Welcome,
    Footer,
    Transition,
    Menu,
  },
  data: function () {
    return {
      showDrama: true,
      aborted: false,
      hidemenu: true,
      showSalmon: false,
      showCyber: false,
      showCisco: false,
    };
  },
  watch: {
    proj: function () {
      console.log(this.$route.query);
      return this.$route.query;
    },
  },
  methods: {
    goto: function (anchorname) {
      document
        .getElementById(anchorname)
        .scrollIntoView({ behavior: "smooth" });
    },
    setsize: function () {
      const appElement = document.getElementById("app");
      const newHeight = window.innerHeight + "px";
      const newWidth = window.innerWidth + "px";
      document.body.style.setProperty("height", newHeight);
      document.body.style.setProperty("width", newWidth);
      appElement.style.setProperty("height", newHeight);
      appElement.style.setProperty("width", newWidth);
    },
    abort: function () {
      this.aborted = true;
      this.hidemenu = false;
    },
    showbtn: function () {
      this.hidemenu = false;
    },
    gotohash() {
      if (this.$route.hash) {
        const jumpto = this.$route.hash;
        document.getElementById(jumpto.substring(1)).scrollIntoView();
        history.replaceState(null, null, "/");
        this.abort();
      }
      if (this.$route.query) {
        const queeryscroll = this.$route.query["scroll"];
        if (queeryscroll) {
          document.getElementById("home").scrollTop = queeryscroll;
          history.replaceState(null, null, "/");
          this.abort();
        }
      }
      if (this.$route.path !== "/") {
        history.replaceState(null, null, "/");
      }
    },
    getScrollPositions() {
      console.log();
    },
  },
  created: function () {
    this.setsize();
    window.addEventListener("resize", this.setsize);
    console.log(this.$route);
  },
  destroyed: function () {
    window.removeEventListener("resize", this.setsize);
  },
  mounted: function () {
    this.$nextTick(this.gotohash);
  },
};
</script>

<style>
#home {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100%;
  width: 100%;
  overflow: auto;
  scroll-snap-type: y proximity;

  overflow-x: hidden;
}

/* .dots {
  background-image: url("@/assets/dots.svg");
}

.hex {
  background-image: url("@/assets/hexadots.svg");
} */

/* .menubtn {
  z-index: 11;
  position: absolute;
  top: 1vmin;
  right: 1vmin;
  display: flex;
  align-items: center;
  justify-content: center;
  stroke: white;
  mix-blend-mode: difference;
}
.menubtnoff {
  opacity: 100%;
}

.menubtnon {
  opacity: 100%;
} */

.slowtrans {
  transition: opacity 1s;
}

.invisible {
  visibility: hidden;
  opacity: 0%;
}
</style>